const CURRENCY_DECIMALS = 2;

// A ceiling, not a measured count: 0.1093 is cents/100, so it arrives as 0.10930000000000001.
const SUB_DOLLAR_DECIMALS = 4;

export function formatCurrency(value: number): string {
  if (value <= 0) {
    return "$0";
  }

  const maximumFractionDigits = maximumFractionDigitsFor(value);

  return new Intl.NumberFormat("en-US", {
    minimumFractionDigits: isWholeDollars(value, maximumFractionDigits)
      ? 0
      : CURRENCY_DECIMALS,
    maximumFractionDigits,
    style: "currency",
    currency: "USD",
  }).format(value);
}

function maximumFractionDigitsFor(value: number): number {
  return value < 1 ? SUB_DOLLAR_DECIMALS : CURRENCY_DECIMALS;
}

function isWholeDollars(value: number, maximumFractionDigits: number): boolean {
  return Number(value.toFixed(maximumFractionDigits)) % 1 === 0;
}
